export default class IframeVideo {
    constructor(el) {
        this.el = el;

        if (document.readyState === 'complete') {
            setTimeout(() => this.setSrc(), 400);
        } else {
            document.addEventListener('readystatechange', event => {
                if (event.target.readyState === 'complete') {
                    setTimeout(() => this.setSrc(), 400);
                }
            });
        }
    }


    // deferred loading of video iframes
    setSrc() {
        if (!this.el.dataset.src || this.el.src) {
            return;
        }
        this.el.setAttribute('src', this.el.dataset.src);
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/IframeVideo.js